<template lang="html">
  <b-navbar id="template-header" 
            class="navbar default-layout col-lg-12 col-12 p-0 fixed-top d-flex flex-row" 
            toggleable="md">
    <div class="text-center navbar-brand-wrapper d-flex align-items-top justify-content-center">
      <router-link class="navbar-brand brand-logo" to="/">
        <img src="../../assets/images/logo.svg" alt="logo" />
      </router-link>
      <router-link class="navbar-brand brand-logo-mini" to="/">
        <img src="../../assets/images/logo-mini.svg" alt="logo" />
      </router-link>
    </div>
    <div class="navbar-menu-wrapper d-flex align-items-center ml-auto ml-lg-0">
      <button class="navbar-toggler navbar-toggler align-self-center" type="button" @click="collapedSidebar()">
        <span class="mdi mdi-menu"></span>
      </button>
      
      <b-navbar-nav class="navbar-nav-right ml-auto">
        <b-nav-item-dropdown id="restaurants-dropdown" right class="preview-list" > 
          <template slot="button-content">
            <div class="d-flex align-items-center">
              <span class="profile-text d-none d-lg-inline">{{currentRestaurant.restaurantName}}</span>
            </div>
          </template>
          <b-dropdown-item v-for="r in restaurants"
                           v-on:click="handleChangeCurrentRestaurant(r)">
                           {{ r.restaurantName }}
          </b-dropdown-item>
        </b-nav-item-dropdown>
        <b-nav-item-dropdown right class="preview-list">
          <template slot="button-content">
            <div class="d-flex align-items-center">
              <img class="img-xs rounded-circle" src="../../assets/images/faces/face8.jpg" alt="Profile image">
            </div>
          </template>
          <b-dropdown-item class="preview-item profile-actions">
            <div class="preview-header">
              <div class="py-3 px-4 d-flex align-items-center justify-content-center">
                <i class="mdi mdi-bookmark-plus-outline mr-0 text-gray"></i>
              </div>
              <div class="py-3 px-4 d-flex align-items-center justify-content-center border-left border-right">
                <i class="mdi mdi-account-outline mr-0 text-gray"></i>
              </div>
              <div class="py-3 px-4 d-flex align-items-center justify-content-center">
                <i class="mdi mdi-alarm-check mr-0 text-gray"></i>
              </div>
            </div>
          </b-dropdown-item>
          <b-dropdown-item>Manage Accounts</b-dropdown-item>
          <b-dropdown-item>Change Password</b-dropdown-item>
          <b-dropdown-item>Sign Out</b-dropdown-item>
        </b-nav-item-dropdown>
      </b-navbar-nav>
      <button class="navbar-toggler navbar-toggler-right align-self-center" type="button" @click="collapedMobileSidebar()">
        <span class="mdi mdi-menu"></span>
      </button>
    </div>
  </b-navbar>
</template>

<script lang="js">
import { mapState, mapActions } from'vuex'
// eslint-disable-next-line
import JQuery from 'jquery'
let $ = JQuery
export default {
  name: 'app-header',
  inject: ['eventBus'],
  computed: {
    ...mapState({
      restaurants: state => state.restaurants.restaurants,
      currentRestaurant: state => state.restaurants.currentRestaurant
    })
  },
  methods: {
    collapedSidebar: function () {
      $('body').toggleClass('sidebar-icon-only')
    },
    collapedMobileSidebar: function () {
      $('#sidebar').toggleClass('active')
    },
    ...mapActions(['restaurants/getRestaurantsAction']),
    handleChangeCurrentRestaurant(restaurant) {
      this.$store.dispatch('restaurants/changeCurrentRestaurantAction', restaurant);
      this.eventBus.$emit("currentRestaurantChangedEvent");
    },
    enableRestaurantsDropdownMenu() {
      console.log('AppHeader: Enable RestaurantsDropdownMenu');
      $('#restaurants-dropdown').attr('disable','false');
    },
    disableRestaurantsDropdownMenu() {
      console.log('AppHeader: Disable RestaurantsDropdownMenu');
      $('#restaurants-dropdown').attr('disable','true');
    }
  },
  created() {
    console.log('AppHeader: Created()');
    this.$store.dispatch('restaurants/getRestaurantsAction');
  },
  mounted() {
    this.eventBus.$on("disableRestaurantsDropdownEvent", this.disableRestaurantsDropdownMenu);
    this.eventBus.$on("enableRestaurantsDropdownEvent", this.enableRestaurantsDropdownMenu);
  },
  destroyed() {
    this.eventBus.$off("disableRestaurantsDropdownEvent", this.disableRestaurantsDropdownMenu);
    this.eventBus.$off("enableRestaurantsDropdownEvent", this.enableRestaurantsDropdownMenu);
  }
}
</script>

<style scoped lang="scss">
.app-header {
}
</style>
